/**
 * Parses a URL query string into an object containing key-value pairs.
 *
 * @param params - The query string from a URL, starting with '?'.
 * @returns An object where each key is a parameter name and each value is the corresponding parameter value.
 *
 * Example:
 * Input: "?name=John&age=30"
 * Output: { name: "John", age: "30" }
 */
export function getParametersInUrl(params: string) {
  const urlArray = params.replace(/^\?/, '').split('&');

  return urlArray.reduce((result, param) => {
    const [key, value] = param.split('=');

    if (key && value) {
      return {
        ...result,
        [key]: value,
      };
    }

    return result;
  }, {});
}
